<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Business Information</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm" class="float-right">
            <b-dropdown-item><b-link href="#" @click="startHowTo('742118627?h=a7d11c42a6', 'Contract Length')">Contract Length</b-link></b-dropdown-item>
            <b-dropdown-item><b-link href="#" @click="startHowTo('735880306?h=c3870991de', 'Ramp Up Period')">Ramp Up Period</b-link></b-dropdown-item>
            <b-dropdown-item><b-link href="#" @click="startHowTo('735880294?h=07085fc717', 'Days on Market')">Days On Market</b-link></b-dropdown-item>
          </b-dropdown>
        </b-card-header>
        <b-card-body>
          <b-form>
            <label class="form-control-label">Average Contract to Close Length <span id="contract-to-close"><i class="fas fa-question-circle"></i></span></label>
            <b-tooltip target="contract-to-close" triggers="hover" variant="primary">
              If unsure, input 45 days. This can be edited in the portal.
            </b-tooltip>
            <base-input type="number"
                        min="0"
                        max="365"
                        rules="required"
                        name="Contract Length"
                        input-group-classes="input-group-merge"
                        prependIcon="fas fa-calendar"
                        v-model="contractLength"
                        helperText="How many days on average does it take in your market to go from contract accepted to contract closed?">
            </base-input>

            <label class="form-control-label">Ramp Up Period <span id="ramp-up-period"><i class="fas fa-question-circle"></i></span></label>
            <b-tooltip target="ramp-up-period" triggers="hover" variant="primary">
              If unsure, input 10 days. This can be edited in the portal.
            </b-tooltip>
            <base-input type="number"
                        min="0"
                        max="365"
                        rules="required"
                        name="Ramp Up"
                        input-group-classes="input-group-merge"
                        prependIcon="fas fa-calendar"
                        v-model="rampUp"
                        helperText="How many days on average does it take to go from listing agreement signed to day one on the market?">
            </base-input>

            <label class="form-control-label">Average Days On Market (DOM) <span id="days-on-market"><i class="fas fa-question-circle"></i></span></label>
            <b-tooltip target="days-on-market" triggers="hover" variant="primary">
              If unsure, input 14 days. This can be edited in the portal.
            </b-tooltip>
            <base-input type="number"
                        min="0"
                        max="365"
                        rules="required"
                        name="DOM"
                        input-group-classes="input-group-merge"
                        prependIcon="fas fa-calendar"
                        v-model="dom"
                        helperText="How many days on average does it take to go from day one on market to contract accepted for your listings?">
            </base-input>

            <b-button variant="success" @click="add">Submit</b-button>
          </b-form>
        </b-card-body>
      </b-card>
    </b-container>
    <how-to-modal :source="howToVideo" :video_title="howToTitle"></how-to-modal>
  </div>
</template>
<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import HowToModal from '@/views/Components/Modals/HowToModal';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    HowToModal
  },
  data() {
    return {
      howToVideo: null,
      howToTitle: null
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    user() {
      return this.$store.getters['profile/user'].slug;
    },
    team() {
      return this.$store.getters['teams/team'];
    },
    contractLength: {
      get() {
        return this.team.contract_length;
      },
      set(value) {
        return this.$store.commit('teams/SET_CONTRACT_LENGTH', value);
      }
    },
    rampUp: {
      get() {
        return this.team.ramp_up;
      },
      set(value) {
        return this.$store.commit('teams/SET_RAMP_UP', value);
      }
    },
    dom: {
      get() {
        return this.team.dom;
      },
      set(value) {
        return this.$store.commit('teams/SET_DOM', value);
      }
    }
  },
  methods: {
    add() {
      axios.patch(this.userRoute + "/teams/" + this.team.slug, {
        contract_length: this.contractLength,
        ramp_up: this.rampUp,
        dom: this.dom
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.$store.dispatch('teams/get', {user: this.user});
      })
      .catch(error => {
        this.error(error);
      });
    },
    startHowTo(video, title) {
      this.howToVideo = video;
      this.howToTitle = title;
      this.$bvModal.show('how-to-modal');
    }
  }
}
</script>